import {App} from './App'
import {Index} from './routes/Index'
import {ShowApp} from './routes/ShowApp'
import {ShowAction} from './routes/ShowAction'
import {IndexModels} from './routes/models/IndexModels'
import {Playground} from './routes/models/Playground'
import {Readme} from './routes/models/Readme'
import {Transparency} from './routes/models/Transparency'
import {Evaluation} from './routes/models/Evaluation'
import {registerReactAppFactory} from '@github-ui/react-core/register-app'
import {jsonRoute} from '@github-ui/react-core/json-route'
import {License} from './routes/models/License'

registerReactAppFactory('marketplace-react', () => ({
  App,
  routes: [
    jsonRoute({path: '/marketplace', Component: Index}),
    jsonRoute({path: '/marketplace/:slug', Component: ShowApp}),
    jsonRoute({path: '/marketplace/actions/:slug', Component: ShowAction}),
    jsonRoute({path: '/marketplace/models', Component: IndexModels}),
    jsonRoute({path: '/marketplace/models/:registry/:model', Component: Readme}),
    jsonRoute({path: '/marketplace/models/:registry/:model/playground', Component: Playground}),
    jsonRoute({path: '/marketplace/models/:registry/:model/transparency', Component: Transparency}),
    jsonRoute({path: '/marketplace/models/:registry/:model/license', Component: License}),
    jsonRoute({path: '/marketplace/models/:registry/:model/evaluation', Component: Evaluation}),
  ],
}))
